// src/utils/formatCNIC.js

export const formatCNIC = (value) => {
  // Remove all non‑digit characters
  const digits = value.replace(/\D/g, "").slice(0, 13);

  // Insert hyphens at positions 5 and 12
  if (digits.length <= 5) return digits;
  if (digits.length <= 12) return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  return `${digits.slice(0, 5)}-${digits.slice(5, 12)}-${digits.slice(12)}`;
};

export const isValidCNIC = (cnic) => /^\d{5}-\d{7}-\d{1}$/.test(cnic);
